import React from 'react';
import { Link } from 'react-router-dom';
import './BlogSidebar.css';

const BlogSidebar = ({ popularPosts, categories }) => {
  return (
    <aside className="blog-sidebar">
      {/* About Widget */}
      <div className="sidebar-widget about-widget">
        <h3>About the Blog</h3>
        <p>
          Our blog provides insights, trends, and best practices in CRM, Ecommerce, 
          and Mobile App Development from our team of experts.
        </p>
      </div>

      {/* Popular Posts */}
      <div className="sidebar-widget">
        <h3>Popular Articles</h3>
        <div className="popular-posts">
          {popularPosts.map(post => (
            <div key={post.id} className="popular-post">
              <Link to={`/blog/${post.slug}`} className="popular-post-image">
                <img src={post.image} alt={post.title} loading="lazy" />
              </Link>
              <div className="popular-post-content">
                <Link to={`/blog/${post.slug}`} className="popular-post-title">
                  {post.title}
                </Link>
                <span className="popular-post-date">{post.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Categories */}
      <div className="sidebar-widget">
        <h3>Categories</h3>
        <ul className="category-list">
          {categories.map(category => (
            <li key={category}>
              <Link to={`/blog/category/${category.toLowerCase()}`}>
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Tags */}
      <div className="sidebar-widget">
        <h3>Tags</h3>
        <div className="tag-cloud">
          {['CRM', 'Ecommerce', 'Mobile Apps', 'UI/UX', 'Security', 'Development', 'Trends', 'Case Studies'].map(tag => (
            <Link key={tag} to={`/blog/tag/${tag.toLowerCase()}`} className="tag">
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default BlogSidebar;